import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    containerCardAgent: {
      width: "374px",
      maxWidth: "374px",
      minWidth: "250px",
      padding: "16px",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    containerImgName: {
      display: "flex",
      flexDirection: "row",
      gap: "16px",
      alignItems: "flex-start",
      minHeight: "75px",
    },
    containerCourses: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    divider: {
      backgroundColor: theme.palette.border.secondary,
    },
    containerHeaderCourse: {
      display: "flex",
      flexDirection: "row",
      gap: "12px",
      alignItems: "center",
    },
    containerCourse: {
      display: "flex",
      flexDirection: "column",
    },
    containerCourses: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
  };
});
